import * as React from 'react'

import styles from './ChatPage.module.scss'

export const ChatPage: React.FC = () => {
  return (
    <div className={styles.chat_page}/>
  )
}
